import { useAxiosModule } from '@/modules/_shared/axios'
import * as types from './types'

const {
    getFromApi,
    postToApi,
    putToApi,
    deleteInApi
} = useAxiosModule()

export type GetSSOJoinRulesListResponse = types.GetSSOJoinRulesList

export async function getSSOJoinRules (search = '', orderBy = 'id desc', limit = 0, offset = 0) {
    const queryParams = new URLSearchParams()
    queryParams.set('search', search)
    queryParams.set('sort', orderBy)
    queryParams.set('limit', String(limit))
    queryParams.set('offset', String(offset))
    const url = 'join-rules?' + queryParams.toString()
    return getFromApi<GetSSOJoinRulesListResponse>(url)
}

export type GetSSOJoinRuleResponse = types.SSOJoinRulesListModel
export const getSSOJoinRule = async (joinRuleId: string) =>
    await getFromApi<GetSSOJoinRuleResponse>(`join-rules/${joinRuleId}`)

export type AddSSOJoinRuleRequest = types.AddSSOJoinRule
export const addSSOJoinRule = async (req: AddSSOJoinRuleRequest) =>
    await postToApi<null>('join-rules/', req)

export type UpdateSSOJoinRuleRequest = types.ChangeSSOJoinRule
export const updateSSOJoinRule = async (joinRuleId: string, req: UpdateSSOJoinRuleRequest) =>
    await putToApi<null>(`join-rules/${joinRuleId}`, req)

export const deleteSSOJoinRule = async (joinRuleId: string) =>
    await deleteInApi<null>(`join-rules/${joinRuleId}`, { joinRuleId: joinRuleId })
